import styled from 'styled-components';

const CenteredLayout = styled.div<CenteredLayoutProps>(({ centerY = false }) =>
  centerY
    ? {
        margin: '0 auto',
        width: 'fit-content',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }
    : {
        margin: '0 auto',
        width: 'fit-content',
      },
);

export type CenteredLayoutProps = {
  centerY?: boolean;
};

export { CenteredLayout };
